export default "__VITE_ASSET__289a0bc0__"